import { Object3D } from "three";
import { IWeapon } from "./IWeapon";

class Barehand implements IWeapon {
    public model: Object3D | null;

    constructor() {
        this.model = null;
    }
}

export default Barehand;
